export class NavToolbarContentConstants {
    static HELP_TOOLTIP = "Help";
    static NOTIFICATION_TOOLTIP = "Notifications";
    static NO_HELP = "No help available currently";
    static FILE_NAME_HELP = "Helpfile.pdf";
    static NO_HELP_FILE_MESSAGE = "No help file is available for this module.";
    static NO_MODULE_SELECTED = "Please open a module before opening the help file";
}
